<template>
  <div class="pageMain"></div>
</template>
<script>
import { storage } from "@/utils/utils";
export default {
  name: "Auth",
  data: function () {
    return {};
  },
  created() {
    this.loading();
    this.checkRouter();
  },
  methods: {
    loading() {
      this.$toast.loading({
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
    },
    checkRouter() {
      if (this.$browserType.browserType() === "zfb") {
          this.$router.replace("/index");
      }
      let $storage = new storage();
      let token = $storage.get("token");
      let auth_back_url = $storage.get("AUTH_BACK_URL");
      if (token || token && auth_back_url) {
        this.$router.replace("/index");
      }
    },
  },
};
</script>
<style scoped></style>
